<div #trailRoot class="d-trail" aria-hidden="true"></div>
